'use client';

import Image from 'next/image';
import Link from 'next/link';

import { cn } from '@kit/ui/utils';

interface BalleeLogoIconProps {
  className?: string;
  size?: 16 | 24 | 32 | 48 | 64;
  href?: string | null;
  'aria-label'?: string;
}

/**
 * BalleeLogoIcon - Favicon/Small Icon variant
 * Uses the existing /balleeLogo.svg asset at small sizes
 */
export function BalleeLogoIcon({
  className,
  size = 32,
  href,
  'aria-label': ariaLabel = 'Ballee',
}: BalleeLogoIconProps) {
  const icon = (
    <Image
      src="/balleeLogo.svg"
      alt=""
      width={size}
      height={size}
      className={cn('inline-block', className)}
      aria-label={ariaLabel}
      role="img"
    />
  );

  if (href != null) {
    return (
      <Link href={href} aria-label={ariaLabel} prefetch={true}>
        {icon}
      </Link>
    );
  }

  return icon;
}
